import React from 'react'

import Header from './pheader'
import Footer from './footer'

export default ({ children }) => (
  <>
    <Header />
    {children}
    <Footer />
  </>
)
